import { useEffect, useState } from "react";
import CommonLayout from "./CommonLayout";
import { useLocation } from "react-router-dom";
import { useZymedOpenedEvent, ZYMED_EVENTS } from "../../../utils/zymedAnalytics";

const MyMainComponent = () => {
  const [showTabsBar, setShowTabsBar] = useState(true);
  const [activeTab, setActiveTab] = useState<
    | "myFeed"
    | "trending"
    | "allNews"
    | "bookmarks"
    | "topicNews"
    | "shotTags"
    | ""
  >("");
  const location = useLocation();
  const { type } = location.state;
  // Home's scroll cards open the feed directly, bypassing the splash entry.
  useZymedOpenedEvent(ZYMED_EVENTS.SHOTS_OPENED, { requireSource: true });

  useEffect(() => {
    if (type) setActiveTab(type);
    setShowTabsBar(true);
  }, [type]);

  const handleShortClick = () => {
    setShowTabsBar(!showTabsBar);
  };

  return (
    <CommonLayout
      setActiveTab={setActiveTab}
      showTabsBar={showTabsBar}
      activeTab={activeTab}
      handleShortClick={handleShortClick}
    />
  );
};

export default MyMainComponent;
